import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { defaultKSK1030_R01DetailDto, defaultKSK1030_R01HeaderDto, defaultKSK1030_R01LotDto, KSK1030_R01DetailDto, KSK1030_R01HeaderDto, KSK1030_R01LotDto } from './Dto_KSK1030_R01';
import { showWarning } from 'src/utils/toast/toastUtil';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';


export interface KSK1030_R01Filter {
}

export interface Store_KSK1030_R01 {
	KSK1030_R01Filter: KSK1030_R01Filter;
	KSK1030_R01PastFilter: KSK1030_R01Filter;
	setKSK1030_R01Filter: (filter: Partial<Store_KSK1030_R01['KSK1030_R01Filter']>) => void;
	setKSK1030_R01PastFilter: (filter: Store_KSK1030_R01['KSK1030_R01PastFilter']) => void;

	editKSK1030_R01: KSK1030_R01HeaderDto | null;
	setEditKSK1030_R01: (editSale: KSK1030_R01HeaderDto | null) => void;

	deletedKSK1030_R01DetailList: string[];
	setDeletedKSK1030_R01DetailList: (idList: string[]) => void;
	addDeletedKSK1030_R01DetailList: (idList: string[]) => void;
	removeDeletedKSK1030_R01DetailList: (idList?: string[]) => void;

	KSK1030_R01DetailList: KSK1030_R01DetailDto[];
	setKSK1030_R01DetailList: (data: KSK1030_R01DetailDto[]) => void;
	insertKSK1030_R01DetailList: (data: KSK1030_R01DetailDto[], index?: number) => void;
	removeKSK1030_R01DetailList: (index: number) => void;
	updateKSK1030_R01DetailList: (index: number, data: KSK1030_R01DetailDto) => void;

	selectedKSK1030_R01DetailList: string[];
	setSelectedKSK1030_R01DetailList: (idList: string[]) => void;
	addSelectedKSK1030_R01DetailList: (idList: string[]) => void;
	removeSelectedKSK1030_R01DetailList: (idList?: string[]) => void;
	initSelectedKSK1030_R01DetailList: () => void;

	originalKSK1030_R01DetailList: KSK1030_R01DetailDto[];
	setOriginalKSK1030_R01DetailList: (data: KSK1030_R01DetailDto[]) => void;

	KSK1030_R01LotMap: Map<string, KSK1030_R01LotDto[]>;
	setKSK1030_R01LotMap: (data: Map<string, KSK1030_R01LotDto[]>) => void;

	selectedItemCdForLot: string | null;
	setSelectedItemCdForLot: (itemCd: string | null) => void;

	setKSK1030_R01LotList: (data: KSK1030_R01LotDto[]) => void;
	insertKSK1030_R01LotList: (data: KSK1030_R01LotDto[], index?: number) => void;
	removeKSK1030_R01LotList: (valueIndex: number) => void;
	updateKSK1030_R01LotList: (valueIndex: number, data: KSK1030_R01LotDto) => void;

	selectedKSK1030_R01LotList: string[];
	setSelectedKSK1030_R01LotList: (idList: string[]) => void;
	addSelectedKSK1030_R01LotList: (idList: string[]) => void;
	removeSelectedKSK1030_R01LotList: (idList?: string[]) => void;
	initSelectedKSK1030_R01LotList: () => void;

	deletedKSK1030_R01LotList: string[];
	setDeletedKSK1030_R01LotList: (idList: string[]) => void;
	addDeletedKSK1030_R01LotList: (idList: string[]) => void;
	removeDeletedKSK1030_R01LotList: (idList?: string[]) => void;

	originalKSK1030_R01LotList: KSK1030_R01LotDto[];
	setOriginalKSK1030_R01LotList: (data: KSK1030_R01LotDto[]) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;
	lotColumnState: ColumnState[] | null;
	setLotColumnState: (state: ColumnState[] | null) => void;

	allCount: number;				setAllCount: (allCount: number) => void;

	transportComplete: boolean;		setTransportComplete: (transportComplete: boolean) => void;
	detailFetchTrigger: boolean;	setDetailFetchTrigger: (detailFetchTrigger: boolean) => void;
	lotFetchTrigger: boolean;		setLotFetchTrigger: (lotFetchTrigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	lotScrollTop: number | null;
	setLotScrollTop: (top: number | null) => void;

	initData: () => void;

	warehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	syncInitialData: () => void;
}

const findSelectedDetail = (
	detailList: KSK1030_R01DetailDto[],
	selectedDetailList: string[],
): KSK1030_R01DetailDto | undefined => {
	if (!selectedDetailList.length) return undefined;
	const selectedValueIndex = selectedDetailList[0]?.toString();
	return detailList.find(d => d.valueIndex.toString() === selectedValueIndex);
};

const resolveLotKey = (detail: KSK1030_R01DetailDto | undefined): string | null => {
	if (!detail?.itemCd) return null;
	return `${detail.itemCd}-${detail.itemStatus || ''}`;
};

export const defaultKSK1030_R01Filter: KSK1030_R01Filter = {};

const getInitialKSK1030_R01HeaderDto = (): KSK1030_R01HeaderDto => {
	const { wmsCdList, warehouseCdList } = useCommonCodeStore.getState();
	return {
		...defaultKSK1030_R01HeaderDto,
		logicCenter: wmsCdList?.[0]?.minorCd || '',
		warehouseCd: warehouseCdList?.[0]?.warehouseCd || '',
		warehouseNm: warehouseCdList?.[0]?.warehouseNm || '',
	};
};

export const useKSK1030_R01Store = create<Store_KSK1030_R01>((set, get) => ({
	KSK1030_R01Filter: defaultKSK1030_R01Filter,
	KSK1030_R01PastFilter: defaultKSK1030_R01Filter,
	setKSK1030_R01Filter: (update) => set((state) => ({
		KSK1030_R01Filter: {
			...state.KSK1030_R01Filter,
			...update,
		},
	})),
	setKSK1030_R01PastFilter: (filter) => set({
		KSK1030_R01PastFilter: filter,
	}),

	editKSK1030_R01: getInitialKSK1030_R01HeaderDto(),
	setEditKSK1030_R01: (editSale: KSK1030_R01HeaderDto | null) => set((state) => ({
		...state,
		editKSK1030_R01: editSale,
	})),

	KSK1030_R01DetailList: [],
	setKSK1030_R01DetailList: (data: KSK1030_R01DetailDto[]) => set((state) => {
		let newList: KSK1030_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0,
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK1030_R01DetailList: newList,
		};
	}),
	insertKSK1030_R01DetailList: (data: KSK1030_R01DetailDto[], index?: number) => set((state) => {
		let newKSK1030_R01DetailList = [...state.KSK1030_R01DetailList];
		let targetRowData = newKSK1030_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		let maxValueIndex = Math.max(0, ...newKSK1030_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		const targetRows = newKSK1030_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if (item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		newKSK1030_R01DetailList = newKSK1030_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK1030_R01DetailList.push(...targetRows);

		const newData = data.map(item => ({
			...defaultKSK1030_R01DetailDto,
			...item,
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq,
		}));
		if (index !== undefined) {
			newKSK1030_R01DetailList.splice(index, 0, ...newData);
		} else {
			newKSK1030_R01DetailList.push(...newData);
		}

		return {
			...state,
			KSK1030_R01DetailList: newKSK1030_R01DetailList,
		};
	}),
	removeKSK1030_R01DetailList: (index: number) => set((state) => ({
		...state,
		KSK1030_R01DetailList: [...state.KSK1030_R01DetailList].filter((item) => item.valueIndex !== index),
	})),
	updateKSK1030_R01DetailList: (valueIndex: number, data: KSK1030_R01DetailDto) => set((state) => ({
		...state,
		KSK1030_R01DetailList: state.KSK1030_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		),
	})),

	deletedKSK1030_R01DetailList: [],
	setDeletedKSK1030_R01DetailList: (idList: string[]) => set((state) => ({
		...state,
		deletedKSK1030_R01DetailList: idList,
	})),
	addDeletedKSK1030_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedKSK1030_R01DetailList];
		for (const valueIndex of idList) {
			const isInserted = state.KSK1030_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK1030_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if (!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		return {
			...state,
			deletedKSK1030_R01DetailList: _deletedDetailList,
		};
	}),
	removeDeletedKSK1030_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedKSK1030_R01DetailList: [...state.deletedKSK1030_R01DetailList].filter(value => idList ? !idList.includes(value) : false),
	})),

	selectedKSK1030_R01DetailList: [],
	setSelectedKSK1030_R01DetailList: (idList: string[]) => set((state) => {
		const selectedDetail = findSelectedDetail(state.KSK1030_R01DetailList, idList);
		return {
			...state,
			selectedKSK1030_R01DetailList: idList,
			selectedItemCdForLot: resolveLotKey(selectedDetail),
			lotFetchTrigger: true,
			lotScrollTop: null,
		};
	}),
	addSelectedKSK1030_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedKSK1030_R01DetailList = [...state.selectedKSK1030_R01DetailList];
		if (idList.length > 0) {
			_selectedKSK1030_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedKSK1030_R01DetailList: _selectedKSK1030_R01DetailList,
		};
	}),
	removeSelectedKSK1030_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedKSK1030_R01DetailList: [...state.selectedKSK1030_R01DetailList].filter(value => idList ? !idList.includes(value) : false),
	})),
	initSelectedKSK1030_R01DetailList: () => set({ selectedKSK1030_R01DetailList: [], lotFetchTrigger: false }),

	originalKSK1030_R01DetailList: [],
	setOriginalKSK1030_R01DetailList: (data: KSK1030_R01DetailDto[]) => set((state) => {
		let newList: KSK1030_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item) => {
			newList.push({
				...defaultKSK1030_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex,
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK1030_R01DetailList: newList,
		};
	}),

	KSK1030_R01LotMap: new Map<string, KSK1030_R01LotDto[]>(),
	setKSK1030_R01LotMap: (data: Map<string, KSK1030_R01LotDto[]>) => set({ KSK1030_R01LotMap: data }),

	selectedItemCdForLot: null,
	setSelectedItemCdForLot: (itemCd) => set({ selectedItemCdForLot: itemCd }),

	setKSK1030_R01LotList: (data: KSK1030_R01LotDto[]) => set((state) => {
		const { KSK1030_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state;

		const newLotMap = new Map(KSK1030_R01LotMap);
		newLotMap.set(selectedItemCdForLot, data);
		return { KSK1030_R01LotMap: newLotMap };
	}),

	insertKSK1030_R01LotList: (data: KSK1030_R01LotDto[], index?: number) => set((state) => {
		const { KSK1030_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state;

		const newLotMap = new Map(KSK1030_R01LotMap);
		let targetList = [...(newLotMap.get(selectedItemCdForLot) || [])];
		let targetRowData = targetList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		let maxValueIndex = Math.max(0, ...targetList.map(item => item.valueIndex || 0)) + 1;

		const targetRows = targetList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if (item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		targetList = targetList.filter(item => item.orderIndex !== targetOrderIndex);
		targetList.push(...targetRows);

		const newData = data.map(item => ({
			...defaultKSK1030_R01LotDto,
			...item,
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq,
		}));
		if (index !== undefined) {
			targetList.splice(index, 0, ...newData);
		} else {
			targetList.push(...newData);
		}

		newLotMap.set(selectedItemCdForLot, targetList);
		return { KSK1030_R01LotMap: newLotMap };
	}),

	removeKSK1030_R01LotList: (valueIndex: number) => set((state) => {
		const { KSK1030_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state;

		const newLotMap = new Map(KSK1030_R01LotMap);
		const targetList = (newLotMap.get(selectedItemCdForLot) || []).filter(item => item.valueIndex !== valueIndex);
		newLotMap.set(selectedItemCdForLot, targetList);
		return { KSK1030_R01LotMap: newLotMap };
	}),

	updateKSK1030_R01LotList: (valueIndex: number, data: KSK1030_R01LotDto) => set((state) => {
		const { KSK1030_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state;

		if (typeof data.inputOutQty !== 'number' || isNaN(data.inputOutQty)) {
			showWarning('출고량은 숫자만 입력할 수 있습니다.');
			data.inputOutQty = 0;
		}
		if (data.inputOutQty > data.lotQty) {
			showWarning('출고량은 재고량보다 클 수 없습니다.');
			data.inputOutQty = data.lotQty;
		}
		if (data.inputOutQty < 0) {
			showWarning('출고량은 0보다 작을 수 없습니다.');
			data.inputOutQty = 0;
		}

		const newLotMap = new Map(KSK1030_R01LotMap);
		const targetList = (newLotMap.get(selectedItemCdForLot) || []).map(item =>
			item.valueIndex === valueIndex
				? { ...data, isModified: Number(data.inputOutQty) > 0 }
				: item
		);
		newLotMap.set(selectedItemCdForLot, targetList);
		return { KSK1030_R01LotMap: newLotMap };
	}),

	deletedKSK1030_R01LotList: [],
	setDeletedKSK1030_R01LotList: (idList: string[]) => set((state) => ({
		...state,
		deletedKSK1030_R01LotList: idList,
	})),
	addDeletedKSK1030_R01LotList: (idList: string[]) => set((state) => {
		const _deletedLotList = [...state.deletedKSK1030_R01LotList];
		const selectedItemKey = state.selectedItemCdForLot;
		const newKSK1030_R01LotList = [...state.KSK1030_R01LotMap.get(selectedItemKey!) || []];

		for (const valueIndex of idList) {
			const isInserted = newKSK1030_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = newKSK1030_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if (!isInserted && !isModified) {
				_deletedLotList.push(valueIndex);
			}
		}

		return {
			...state,
			deletedKSK1030_R01LotList: _deletedLotList,
		};
	}),
	removeDeletedKSK1030_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		deletedKSK1030_R01LotList: [...state.deletedKSK1030_R01LotList].filter(value => idList ? !idList.includes(value) : false),
	})),

	selectedKSK1030_R01LotList: [],
	setSelectedKSK1030_R01LotList: (idList: string[]) => set((state) => ({
		...state,
		selectedKSK1030_R01LotList: idList,
	})),
	addSelectedKSK1030_R01LotList: (idList: string[]) => set((state) => {
		const _selectedKSK1030_R01LotList = [...state.selectedKSK1030_R01LotList];
		if (idList.length > 0) {
			_selectedKSK1030_R01LotList.push(...idList);
		}
		return {
			...state,
			selectedKSK1030_R01LotList: _selectedKSK1030_R01LotList,
		};
	}),
	removeSelectedKSK1030_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		selectedKSK1030_R01LotList: [...state.selectedKSK1030_R01LotList].filter(value => idList ? !idList.includes(value) : false),
	})),
	initSelectedKSK1030_R01LotList: () => set({ selectedKSK1030_R01LotList: [] }),

	originalKSK1030_R01LotList: [],
	setOriginalKSK1030_R01LotList: (data: KSK1030_R01LotDto[]) => set((state) => {
		let newList: KSK1030_R01LotDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item) => {
			newList.push({
				...defaultKSK1030_R01LotDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex,
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK1030_R01LotList: newList,
		};
	}),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),
	lotColumnState: null,
	setLotColumnState: (state: ColumnState[] | null) => set({ lotColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),

	transportComplete: false,		setTransportComplete: (transportComplete: boolean) => set({ transportComplete }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (detailFetchTrigger: boolean) => set({ detailFetchTrigger }),
	lotFetchTrigger: false,			setLotFetchTrigger: (lotFetchTrigger: boolean) => set({ lotFetchTrigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
	lotScrollTop: null,
	setLotScrollTop: (top: number | null) => set({ lotScrollTop: top }),

	initData: () => {
		set((state) => ({
			...state,
			KSK1030_R01Filter: defaultKSK1030_R01Filter,
			KSK1030_R01PastFilter: defaultKSK1030_R01Filter,
			KSK1030_R01LotMap: new Map<string, KSK1030_R01LotDto[]>(),
			originalKSK1030_R01LotList: [],
			selectedItemCdForLot: null,
			KSK1030_R01DetailList: [],
			deletedKSK1030_R01DetailList: [],
			selectedKSK1030_R01DetailList: [],
			originalKSK1030_R01DetailList: [],
			deletedKSK1030_R01LotList: [],
			selectedKSK1030_R01LotList: [],
			editKSK1030_R01: getInitialKSK1030_R01HeaderDto(),
			allCount: 0,
			transportComplete: false,
			detailFetchTrigger: false,
			lotFetchTrigger: false,
			scrollTop: null,
			detailScrollTop: null,
			lotScrollTop: null,
		}));
	},

	warehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		const filteredList = warehouseCdList.filter(value => (
			value.logicCenter === logicCenter
			&& (value.goodsYn === 'Y' || value.productYn === 'Y')
		));

		if (filteredList.length === 0) {
			return [{ warehouseCd: '', warehouseNm: '' } as WareHouseDto];
		}

		return filteredList;
	},

	syncInitialData: () => {
		const { wmsCdList } = useCommonCodeStore.getState();
		const state = get();

		if ((state.editKSK1030_R01?.logicCenter && state.editKSK1030_R01?.warehouseCd) || wmsCdList.length === 0) return;

		const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
		const availableWarehouses = state.warehouseCdListToUseList(defaultLogicCenter);
		const defaultWarehouseCd = availableWarehouses?.[0]?.warehouseCd || '';
		const defaultWarehouseNm = availableWarehouses?.[0]?.warehouseNm || '';

		set((state) => ({
			editKSK1030_R01: {
				...state.editKSK1030_R01!,
				logicCenter: defaultLogicCenter,
				warehouseCd: defaultWarehouseCd,
				warehouseNm: defaultWarehouseNm,
			},
		}));
	},
}));
